/*
 * BOMESEL — "Upgrade to the Full Kit" button in the cart drawer.
 *
 * Shopify's Cart AJAX API cannot change the variant on an existing line, so an
 * upgrade is remove-then-add. The line's quantity and its line-item properties
 * (the chosen hand cream fragrance) are read first and carried over, otherwise
 * the customer would silently lose their fragrance choice on upgrade.
 *
 * Listener is delegated from document and guarded, because Dawn replaces the
 * drawer's innerHTML on every cart update, which would drop a bound handler.
 */
(function () {
  if (window.__nkCartUpsellInit) return;
  window.__nkCartUpsellInit = true;

  var ENDPOINT_JSON = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function refreshDrawer(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('cart-drawer');
    var live = document.querySelector('cart-drawer');
    if (!fresh || !live) return false;
    live.innerHTML = fresh.innerHTML;
    live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));

    var freshBubble = parsed.querySelector('#cart-icon-bubble');
    var liveBubble = document.querySelector('#cart-icon-bubble');
    if (sections['cart-icon-bubble'] && liveBubble) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var nb = b.querySelector('#cart-icon-bubble');
      if (nb) liveBubble.innerHTML = nb.innerHTML;
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-upsell-btn]');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('[data-nk-upsell]');
    if (!card) return;

    var targetId = Number(card.getAttribute('data-variant'));
    var lineNo = parseInt(card.getAttribute('data-line'), 10);
    if (!targetId || !lineNo) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Upgrading...';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[lineNo - 1];
        if (!item) throw new Error('line not found');
        var carry = { quantity: item.quantity, properties: item.properties || {} };
        return fetch('/cart/change.js', {
          method: 'POST', headers: ENDPOINT_JSON,
          body: JSON.stringify({ line: lineNo, quantity: 0 })
        }).then(function () { return carry; });
      })
      .then(function (carry) {
        return fetch('/cart/add.js', {
          method: 'POST', headers: ENDPOINT_JSON,
          body: JSON.stringify({
            items: [{ id: targetId, quantity: carry.quantity, properties: carry.properties }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!refreshDrawer(data.sections)) window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
